<header class="dialog-header">
  <h3 class="header-heading">{{ 'pages.userFamily.title' | translate }}</h3>
  <button 
    class="close-button" 
    (click)="closeDialog()"
  ></button>
</header>

<div class="progress">
  <div
    *ngFor="let step of steps; let i = index"
    class="step-progress"
    [class.active]="getActiveStepIndex() === i"
  >
    <div class="chip">{{ i + 1 }}</div>
    <h4 class="step-text">{{ step }}</h4>
  </div>
</div>

<!-- Show dialog content for steps 0 and 1 (pick member and confirm) -->
<div class="dialog-content" *ngIf="stepIndex < 2">
  <mat-spinner *ngIf="loading" diameter="20"></mat-spinner>

  <div class="step" *ngIf="stepIndex === 0">
    <app-step-members *ngIf="familyLinks?.length" [familyMemberList]="familyLinks" (familyMemberClickedEvent)="currentMemberChanged($event)"></app-step-members>
  </div>

  <div class="step" *ngIf="stepIndex === 1">
    <app-step-confirm [selectedProfile]="profile" [selectedFamilyMember]="currentMember" [approvalGuidelines]="approvalGuidelines"></app-step-confirm>
  </div>
</div>

<!-- Show footer for steps 0 and 1 -->
<footer class="dialog-footer" *ngIf="stepIndex < 2">
  <button
    *ngIf="stepIndex > 0"
    (click)="back()"
    class="bciti-inline-button back-button">
    {{ 'pages.userFamily.button.back' | translate }}
  </button>
  <div class="spacer"></div>
  <div class="row" (click)="submitClicked(stepIndex)">
    <button *ngIf="stepIndex === 0"
      (click)="next($event)"
      [disabled]="currentMember == null"
      class="bciti-button bciti-button--blue next-button">
      {{ 'pages.userFamily.button.next' | translate }}
    </button>
    <button *ngIf="stepIndex === 1"
      class="bciti-button bciti-button--red next-button mr-s"
      (click)="submit(false)"
      [disabled]="processingSubmit">
      <span>{{ 'pages.userFamily.button.deny' | translate }}</span>
    </button>
    <button *ngIf="stepIndex === 1"
      class="bciti-button bciti-button--blue next-button"
      (click)="submit(true)"
      [disabled]="processingSubmit">
      <span>{{ 'pages.userFamily.button.accept' | translate }}</span>
    </button>
    <mat-spinner *ngIf="processingSubmit" diameter="20"></mat-spinner>
  </div>
</footer>

<!-- Show card form when stepIndex >= 2 and there's card data -->
<app-step-card *ngIf="stepIndex >= 2 && cardFormData"
  [data]="cardFormData"
></app-step-card>
